import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation-laboratoire',
  templateUrl: './navigation-laboratoire.component.html',
  styleUrls: ['./navigation-laboratoire.component.css']
})
export class NavigationLaboratoireComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/shared/navigation-laboratoire/navigation-laboratoire.component.ts